import './Coach.css';

const Coach = () => {
  return (
    <>
      <h1 className="coach-title">Coming soon</h1>
    </>
  );
};

export default Coach;
